<script setup>
import {ref, computed, onMounted} from 'vue'
import {useStore} from "vuex";
import axios from "axios";
import {priceFormat} from '@/use/price-format'
//----------------------------------------------------------------------
const store = useStore()
const status = ref([])
const isLoading = ref(false)

onMounted( ()=>{
  init()
})

const init = async () => {
  isLoading.value = true
  store.commit('menuModule/initMenu')
  let url = process.env.VUE_APP_API + 'status.php'
  await axios
      .get(`${url}?token=${token.value}&section=${user.value.type}&regNum=${user.value.id}&birthday=${user.value.birthday}`)
      .then(response => (status.value = response.data))
      .catch(error => alert(error));

  //console.log(user.value)
  //console.log(status.value)

  if (status.value.length === 0) {
    setTimeout(() => isLoading.value = false, 3000);
  } else {
    isLoading.value = false
  }
}
//----------------------------------------------------------------------
const token = computed( () => {return store.getters['authModule/token']})
const user = computed( () => {return store.getters['authModule/user']})
</script>

<template>
  <section class="content-header">
    <div class="container-fluid">
      <div class="row">
        <div class="col-12">
          <h3>Статус участника</h3>
        </div>
      </div>
    </div>
  </section>

  <section class="content">
    <div class="container-fluid">
      <div class="row" v-if="status.length === 1 && status[0]['programNum']">

        <div class="col-12 mb-4">
          <h4>{{ status[0]['programName'] }}</h4>
          Данные обновлены {{ status[0]['update'] }}
        </div>
        <div class="col-12 mb-4">

          <div v-if="status[0]['num']>0" class="alert-info p-2 mb-4 rounded d-flex align-items-center">
            <v-icon
                icon="mdi:check-circle-outline"
                class="icon--light-big mr-2"
            ></v-icon>
            <div style="font-size: 1.3rem">Ваша очередь на оказание содействия - № {{ status[0]['num'] }}</div>
          </div>

          <div v-else-if="status[0]['num']==0" class="alert-info p-2 mb-4 rounded d-flex align-items-center">
            <div style="font-size: 1.2rem">Вы включены в Сводный список на 2025 год.
              <br>Вам необходимо предоставить документы для получения социальной выплаты.</div>
          </div>

          <div v-else class="alert-danger p-2 mb-4 rounded d-flex align-items-center">
            <div style="font-size: 1.2rem">Вы исключены из Сводного списка на 2025 год.
              <br>Содействие в рамках программы может быть оказано в более поздние сроки с учетом лимитов финансирования.</div>
          </div>

          <div v-if="status[0]['programNum'] === 4">
            <p>В рамках целевой программы «Молодежи – доступное жилье» (получение целевого жилищного займа):</p>
            <ol>
              <li>В первую очередь рассматриваются документы заявителей, которые имеют первоочередное право на получение государственного содействия в соответствии с Программой с учетом наиболее ранней даты постановки заявителей на учет нуждающихся в улучшении жилищных условий.</li>
              <li>Во вторую очередь рассматриваются документы заявителей, которые не имеют первоочередного права на получение государственного содействия в соответствии с Программой, но имеют наиболее раннюю дату постановки на учет нуждающихся в улучшении жилищных условий.</li>
            </ol>
          </div>

        </div>

        <div class="col-md-4 col-sm-12 mb-3">
          <div class="card card-outline card-info">
            <div class="card-header text-center">
              <v-icon
                  class="data-icon"
                  icon="mdi:alert-circle-outline"
              ></v-icon>
              <br>{{ status[0]['regNum'][0] }}</div>
            <div class="card-body text-center"><h4>{{ status[0]['regNum'][1] }}</h4></div>
          </div>
        </div>
        <div class="col-md-4 col-sm-12 mb-3">
          <div class="card card-outline card-info">
            <div class="card-header text-center">
              <v-icon
                  class="data-icon"
                  icon="mdi:calendar-month-outline"
              ></v-icon>
              <br>{{ status[0]['date1'][0] }}</div>
            <div class="card-body text-center"><h4>{{ status[0]['date1'][1] }}</h4></div>
          </div>
        </div>
        <div class="col-md-4 col-sm-12 mb-3">
          <div class="card card-outline card-info">
            <div class="card-header text-center">
              <v-icon
                  class="data-icon"
                  icon="mdi:calendar-check-outline"
              ></v-icon>
              <br>{{ status[0]['date2'][0] }}</div>
            <div class="card-body text-center"><h4>{{ status[0]['date2'][1] }}</h4></div>
          </div>
        </div>

        <div class="col-md-4 col-sm-12 mb-3">
          <div class="card card-outline card-info">
            <div class="card-header text-center">
              <v-icon
                  class="data-icon"
                  icon="mdi:counter"
              ></v-icon>
              <br>{{ status[0]['queue'][0] }}</div>
            <div class="card-body text-center"><h4>{{ status[0]['queue'][1] }}</h4></div>
          </div>
        </div>
        <div class="col-md-4 col-sm-12 mb-3">
          <div class="card card-outline card-info">
            <div class="card-header text-center">
              <v-icon
                  class="data-icon"
                  icon="mdi:email-outline"
              ></v-icon>
              <br>{{ status[0]['email'][0] }}</div>
            <div class="card-body text-center">
              <h4 v-if="status[0]['email'][1] != ''">{{ status[0]['email'][1] }}</h4>
              <h4 v-else>не указан</h4>
            </div>
          </div>
        </div>
        <div class="col-md-4 col-sm-12 mb-3">
          <div class="card card-outline card-info">
            <div class="card-header text-center">
              <v-icon
                  class="data-icon"
                  icon="mdi:map-marker-circle"
              ></v-icon>
              <br>{{ status[0]['raion'][0] }}</div>
            <div class="card-body text-center"><h4>{{ status[0]['raion'][1] }}</h4></div>
          </div>
        </div>

        <div class="col-md-4 col-sm-12 mb-3">
          <div class="card card-outline card-info">
            <div class="card-header text-center">
              <v-icon
                  class="data-icon"
                  icon="mdi:check-circle-outline"
              ></v-icon>
              <br>{{ status[0]['prioritet'][0] }}</div>
            <div class="card-body text-center">
              <h4 v-if="+status[0]['prioritet'][1] === 0">-</h4>
              <h4 v-else>есть</h4>
            </div>
          </div>
        </div>
        <div class="col-md-4 col-sm-12 mb-3">
          <div class="card card-outline card-info">
            <div class="card-header text-center">
              <v-icon
                  class="data-icon"
                  icon="mdi:information-outline"
              ></v-icon>
              <br>{{ status[0]['pravo'][0] }}</div>
            <div class="card-body text-center"><h4>{{ status[0]['pravo'][1] }}</h4></div>
          </div>
        </div>
        <div class="col-md-4 col-sm-12 mb-3">
          <div class="card card-outline card-info d-none">
            <div class="card-header text-center">
              <v-icon
                  class="data-icon"
                  icon="mdi:currency-rub"
              ></v-icon>
              <br>{{ status[0]['summa'][0] }}</div>
            <div class="card-body text-center"><h4>{{ priceFormat(status[0]['summa'][1]) }}</h4></div>
          </div>
        </div>
      </div>

      <!-- Если данных о статусе нет -->

      <div v-else class="w-100 d-flex justify-content-center">
        <div
            v-if="isLoading"
            class="spinner-border text-primary m-4" role="status"
        ></div>
        <div v-else class="p-4">
          Данные о статусе участника еще не выгружены в личный кабинет или содействие уже оказывается.
        </div>
      </div>
    </div>
  </section>

</template>
<style scoped>
.data-icon{
  width:40px;
  height:40px;
  color: #17a2b8;
  margin:0 0 10px 0;
}
</style>